<template>
    <el-dialog class="dialog dialog-mini" :visible="dialogs.ork" customClass="dialog_main dialog-mini_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Создание отраслевой рамки квалификаций</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form class="search-form" @submit.prevent="submitSelected">
                <div class="dialog__content">
                    <validate-input v-model="orkName" placeholder="Название отраслевой рамки" v-bind:error="orkNameError" v-on:update:error="orkNameError = $event" :validateOptions="['empty']"/>

                    <el-checkbox v-if="user.role_id !== 1" class="mt-16" v-model="autoload">Автоматически загрузить ОПД и ВПД/ПС для СПК</el-checkbox>
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item">
                            <button type="button" class="btn" @click="closeDialog">Отменить</button>
                        </div>
                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action" :disabled="!orkName.length || orkNameError">Создать</button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

export default {
    mixins: [ dialog ],
    components: {
        ValidateInput
    },
    data() {
        return {
            orkName: '',
            orkNameError: false,
            autoload: false
        }
    },
    methods: {
        ...mapActions('ork', ['CREATE_ORK']),
        ...mapMutations('common', ['TOGGLE_ALERT']),

        closeDialog() {
            this.orkName = ''
            this.orkNameError = false

            this.elDialogs.ork = false;
        },
        async submitSelected() {
                const params = {
                    name: this.orkName,
                    autoload: this.autoload
                }
    
                let data = await this.CREATE_ORK(params);
                if (data) {
                  this.closeDialog()
                  this.$router.push({ path: `/editor/${data.id}` }).catch(()=>{});
                }
        }
    },
    computed: {
        ...mapState('ork', ['orkList']),
        ...mapState('user', ['user']),
    }
}
</script>
